module.exports = __webpack_public_path__ + "static/media/documentsImage.edd8f6b7.jpg";